import {Component, Input} from '@angular/core';
import {KYCCorporateProfile, KYCStatus} from "../../../api/entity/kyc-verification";


@Component({
    selector: 'tfl-bo-kyc-results-corporate',
    template: `
        <tfl-bo-kyc-results-block
            title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.COMPANY' | translate }}"
            [result]="{status: results.company_status, company: results.company}">
        </tfl-bo-kyc-results-block>

        <tfl-bo-kyc-results-block
            *ngFor="let signatory of results.signatories"
                title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.SIGNATORY' | translate }}"
                [result]="signatory">
        </tfl-bo-kyc-results-block>

        <tfl-bo-kyc-results-block
            title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.DIRECTORS' | translate }}">
            <tfl-bo-kyc-results-block
                *ngFor="let item of results.directors; let i=index;"
                [profileBadge]="true"
                title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.DIRECTOR' | translate }} {{i + 1}}"
                [result]="item">
            </tfl-bo-kyc-results-block>
        </tfl-bo-kyc-results-block>

        <tfl-bo-kyc-results-block
            title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.SHAREHOLDERS' | translate }}">
            <tfl-bo-kyc-results-block
                *ngFor="let item of results.shareholders; let i=index;"
                [profileBadge]="true"
                title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.SHAREHOLDER' | translate }} {{i + 1}}"
                [result]="item">
            </tfl-bo-kyc-results-block>
        </tfl-bo-kyc-results-block>
    `
})
export class KYCResultsCorporateComponent {
    @Input() results: KYCCorporateProfile;
    @Input() summaryStatus: KYCStatus;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/results/kyc-results.corporate.component.ts